<script>
import request from '@/services/request'
import { mapActions } from 'vuex';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
    },
    data() {
        return {
            errors: {},
            payroll: null,
            files: null,
            load: true,
            location: window.location.href.includes('pay_roll')
        }
    },
    methods: {
        closedModal() {
            this.load = false;
            this.pays = {};
            this.$modal.hide('ListFiles');
        },
        async list() {
            this.load = true;
            let service = request;
            let search = {
                'id': this.payroll.id
            };
            let _endpoint = '/catalogue/list_files';
            try {
                let { data } = await service.get(_endpoint, search)
                if (data) {
                    console.log(data);
                    this.files = data;
                    this.load = false;
                }
            } catch (error) {
                this.load = false;
                console.log(error);
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-listFiles", (payroll) => {
            this.payroll = payroll;
            this.list();
            this.$modal.show('ListFiles');
        });
        Event.$on("event-load-files", () => {
            this.list();
        });
    }
}
</script>
<template>
    <modal name="ListFiles" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Lista de archivos</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <div class="clearfix"></div>
                    <hr>
                    <div class="table-responsive">
                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nombre</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>
                            <tbody v-if="load">
                                <tr>
                                    <td align="center" colspan="6">
                                        <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                        <h5>Cargando</h5>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else-if="files.length > 0">
                                <tr v-for="(file, index) in files" :key="index">
                                    <td>{{ file.id }}</td>
                                    <td>
                                        {{ file.name }}
                                    </td>
                                    <td>
                                        <a :href="`${globalUrlFiles}${file.file}`" v-if="file.file" target="_blank"
                                            style="border-radius: 5px 0px 5px 0px;"
                                            class="btn btn-outline-info m-1 btn-sm">
                                            <i class="fa-regular fa-file-pdf"></i> Descargar
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td align="center" colspan="6">Sin archivos.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>